export default "__VITE_ASSET__CGyJaNb2__"